import React, { useState } from 'react';
import { Navbar } from '../Navbar';
import { TeacherSidebar } from '../TeacherSidebar';
import { Footer } from '../Footer';
import { MenuIcon, XIcon } from 'lucide-react';
import { useTheme } from '../providers/ThemeProvider';
interface TeacherLayoutProps {
  children: React.ReactNode;
}
export const TeacherLayout: React.FC<TeacherLayoutProps> = ({
  children
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isPinned, setIsPinned] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  const isExpanded = isPinned || isHovered;
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const handlePinToggle = () => {
    setIsPinned(prev => !prev);
  };
  const handleArrowToggle = () => {
    if (isPinned) {
      // Unpin and collapse
      setIsPinned(false);
      setIsHovered(false);
    } else {
      // Pin open
      setIsPinned(true);
    }
  };
  const handleMouseEnter = () => {
    if (!isPinned) {
      setIsHovered(true);
    }
  };
  const handleMouseLeave = () => {
    if (!isPinned) {
      setIsHovered(false);
    }
  };
  return <div className={`min-h-dvh ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gray-50'}`} data-id="element-1644">
      <Navbar setIsDeleteAccountModalOpen={() => {}} data-id="element-1645" />
      {/* Mobile sidebar toggle button */}
      <div className="lg:hidden fixed bottom-6 right-6 z-50" data-id="element-1646">
        <button onClick={toggleSidebar} className="bg-deep-pink hover:bg-burgundy text-white p-3 rounded-full shadow-lg transition-colors" aria-label={sidebarOpen ? 'Close sidebar' : 'Open sidebar'} data-id="element-1647">
          {sidebarOpen ? <XIcon className="h-6 w-6" data-id="element-1648" /> : <MenuIcon className="h-6 w-6" data-id="element-1649" />}
        </button>
      </div>
      <div className="flex" data-id="element-1650">
        {/* Desktop sidebar - hover expand + pin */}
        <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{
        width: isExpanded ? 256 : 72
      }} className={`hidden lg:flex flex-col fixed h-full overflow-y-auto overflow-x-hidden pt-20 ${isDark ? 'bg-navy-800 shadow-lg' : 'bg-white shadow-md'} z-20 transition-all duration-200 ease-in-out`} data-id="element-1651">
          <TeacherSidebar isExpanded={isExpanded} isPinned={isPinned} onPinToggle={handlePinToggle} onArrowToggle={handleArrowToggle} data-id="element-1652" />
        </div>
        {/* Mobile sidebar - overlay */}
        {sidebarOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden" onClick={() => setSidebarOpen(false)} data-id="element-1653"></div>}
        {/* Mobile sidebar - content */}
        <div className={`fixed inset-y-0 left-0 z-20 w-64 ${isDark ? 'bg-navy-800 shadow-lg' : 'bg-white shadow-md'} transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out lg:hidden`} data-id="element-1654">
          <div className="pt-20" data-id="element-1655">
            <TeacherSidebar isExpanded={true} isPinned={true} onPinToggle={() => {}} onArrowToggle={() => {}} closeSidebar={() => setSidebarOpen(false)} data-id="element-1656" />
          </div>
        </div>
        {/* Main content - shifts with sidebar */}
        <div style={{
        paddingLeft: undefined
      }} className={`w-full pt-20 transition-[padding-left] duration-200 ease-in-out ${isPinned ? 'lg:pl-64' : 'lg:pl-[72px]'}`} data-id="element-1657">
          <main className={`p-6 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-1658">
            {children}
          </main>
        </div>
      </div>
      <Footer data-id="element-1659" />
    </div>;
};